/**
 * MilestoneBanner.js
 *
 * FT-161 Phase 1: Milestone banners for LET GO and ALL FAST
 * Full-width dark slate banners that mark voyage transitions
 */

import React from 'react';
import { Anchor, Flag } from 'lucide-react';

const MilestoneBanner = ({ entry }) => {
  const isLetGo = entry.milestoneType === 'let_go';

  // Format timestamp
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Choose icon based on type
  const Icon = isLetGo ? Anchor : Flag;

  // Label
  const label = isLetGo ? 'LET GO' : 'ALL FAST';

  return (
    <div className="bg-slate-800 text-white rounded-lg py-3 px-4 mb-3 flex items-center gap-3">
      <Icon className="h-5 w-5 flex-shrink-0" />
      <span className="font-bold text-base">{label}</span>
      {entry.location && (
        <span className="text-slate-300">— {entry.location}</span>
      )}
      <span className="ml-auto text-sm text-slate-400 font-mono">
        {formatTime(entry.timestamp)}
      </span>
    </div>
  );
};

export default MilestoneBanner;
